var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4112 8.09456C15.4112 12.3432 11.9379 15.7855 7.72027 15.7855C3.47166 15.7855 0.0293445 12.3432 0.0293445 8.09456C0.0293445 3.87695 3.47166 0.40363 7.72027 0.40363C11.9379 0.40363 15.4112 3.87695 15.4112 8.09456ZM7.72027 9.64515C6.91397 9.64515 6.29373 10.2964 6.29373 11.0717C6.29373 11.878 6.91397 12.4982 7.72027 12.4982C8.49557 12.4982 9.14682 11.878 9.14682 11.0717C9.14682 10.2964 8.49557 9.64515 7.72027 9.64515ZM6.35575 4.5282L6.57284 8.74581C6.60385 8.96289 6.75891 9.08694 6.94498 9.08694H8.46456C8.65063 9.08694 8.80569 8.96289 8.8367 8.74581L9.05378 4.5282C9.08479 4.31112 8.89872 4.12505 8.68164 4.12505H6.7279C6.51081 4.12505 6.32474 4.31112 6.35575 4.5282Z",
    fill: "#F36262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWarning);
export default __webpack_public_path__ + "static/media/ChatWarning.25dd0cf53fbe737945c7a22bb8b64682.svg";
export { ForwardRef as ReactComponent };